import React, { memo } from "react";
import { css, useTheme } from "@emotion/react";

type TwoColumnProps = {
    children: React.ReactNode,
    className?: string,
}

const TwoColumn: React.FC<TwoColumnProps> = ({ children, className }) => {
    const theme = useTheme();

    const twoColumnStyle = css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 22px;

        ${theme.breakpoints.down('xs')} {
            display: flex;
            flex-direction: column;
            column-gap: unset;
        }

        > div:last-child {
            margin-bottom: 19px;
        }
    `;

    return (
        <div css={twoColumnStyle} className={className}>{children}</div>
    );
}

export default memo(TwoColumn);
